import produce, { castDraft, } from 'immer';
import { EntitiesActionType, } from './actions';
const entityClassesByProjectIdByEntityIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case EntitiesActionType.SET_ENTITY_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId, entityClasses } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                entityClasses.forEach((entityClass) => {
                    temp[entityClass.entityClass] = castDraft(entityClass);
                });
            });
        case EntitiesActionType.SET_ENTITY_CLASS:
            return produce(currentState, (draft) => {
                const { projectId, entityClass } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[entityClass.entityClass] = castDraft(entityClass);
            });
        case EntitiesActionType.CLEAR_ENTITY_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const entityClassIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case EntitiesActionType.SET_ENTITY_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId, entityClasses } = action;
                draft[projectId] = entityClasses.map((entityClass) => {
                    return entityClass.entityClass;
                });
            });
        case EntitiesActionType.CLEAR_ENTITY_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const entitiesByProjectIdByEntityIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case EntitiesActionType.SET_ENTITIES:
            return produce(currentState, (draft) => {
                const { projectId, entities } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                entities.items.forEach((entity) => {
                    temp[entity.entityId] = castDraft(entity);
                });
            });
        case EntitiesActionType.SET_ENTITY:
            return produce(currentState, (draft) => {
                const { projectId, entity } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[entity.entityId] = castDraft(entity);
            });
        case EntitiesActionType.CLEAR_ENTITIES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
const entityIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case EntitiesActionType.SET_ENTITIES:
            return produce(currentState, (draft) => {
                const { projectId, entities, searchParams } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                temp[searchParams] = {
                    range: entities.range,
                    items: entities.items.map((entity) => {
                        return entity.entityId;
                    }),
                };
            });
        case EntitiesActionType.CLEAR_ENTITIES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                delete draft[projectId];
            });
        default:
            return currentState;
    }
};
export const entitiesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.entitiesByProjectIdByEntityId = castDraft(entitiesByProjectIdByEntityIdReducer(currentState.entitiesByProjectIdByEntityId, action));
        draft.entityIdsByProjectId = castDraft(entityIdsByProjectIdReducer(currentState.entityIdsByProjectId, action));
        draft.entityClassesByProjectIdByEntityClassId = castDraft(entityClassesByProjectIdByEntityIdReducer(currentState.entityClassesByProjectIdByEntityClassId, action));
        draft.entityClassIdsByProjectId = castDraft(entityClassIdsByProjectIdReducer(currentState.entityClassIdsByProjectId, action));
    });
};
